import { netsAnalysisType } from "../../constants/netsSubtitles";

export const netTitleToSubtitle = (netTitle: string) => {
  const referenceTitle = netTitle
    .toLowerCase()
    .replaceAll("_", "")
    .replaceAll(" ", "")
    .replaceAll("weight", "");
  const relevantKey = Object.keys(netsAnalysisType).find((key) =>
    referenceTitle.includes(key),
  );
  return relevantKey
    ? netsAnalysisType[relevantKey as keyof typeof netsAnalysisType]
    : undefined;
};
